import { createRoot } from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import { CustomerBookingflowApp, DeskBookingflowApp } from './apps'
import { globalStyles } from '@raskrask-dk/rr-components'
import TagManager from 'react-gtm-module'
import { hotjar } from 'react-hotjar'
import ReactPixel from 'react-facebook-pixel'

const tagManagerArgs = {
    gtmId: 'GTM-TBHBQGC',
}

TagManager.initialize(tagManagerArgs)
hotjar.initialize(1657642, 6, false)
ReactPixel.init('1388759814483497')
ReactPixel.pageView()

globalStyles()

const container = document.getElementById('root')
const root = createRoot(container!) // createRoot(container!) if you use TypeScript

root.render(<CustomerBookingflowApp />)
// root.render(<DeskBookingflowApp />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
export { CustomerBookingflowApp, DeskBookingflowApp }
